module.exports = __webpack_public_path__ + "img/Kh.a3d8ae04.png";